
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M17.5 12h-16V2a.997.997 0 011-1h15a.997.997 0 011 1v9a.997.997 0 01-1 1z","stroke":"#00D6AA","stroke-width":"2"}}),_c('path',{attrs:{"fill":"#00D6AA","fill-opacity":".5","d":"M2.5 5h3v3h-3zM5.5 8h3v3h-3zM5.5 2h3v3h-3zM11.5 8h3v3h-3zM11.5 2h3v3h-3zM8.5 5h3v3h-3zM14.5 5h3v3h-3z"}}),_c('path',{attrs:{"fill":"#00D6AA","d":"M.5 3h2v14h-2z"}})])])
          )
        }
      }
    